import { SecretValue } from "../Apps/common";
import { environmentHttpClient } from "../httpClient";

export enum IntercomRegion {
	Us = 0,
	Eu = 1,
	Au = 2
}

export type IntercomConnectionViewModel = {
	appId: string;
	region: IntercomRegion;
};

export function getConfiguration(
	signal?: AbortSignal
): Promise<OptionalModel<IntercomConnectionViewModel>> {
	return environmentHttpClient.get<OptionalModel<IntercomConnectionViewModel>>(
		"/UiApi/IntercomConfiguration",
		undefined,
		{ signal }
	);
}

export type IntercomConnectionSaveModel = {
	appId: string;
	region: IntercomRegion;
	signingKey: SecretValue;
};

export function setConfiguration(
	model: IntercomConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/IntercomConfiguration",
		model,
		{ signal }
	);
}

export function deleteConfiguration(signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.delete<void>(
		"/UiApi/IntercomConfiguration",
		undefined,
		{ signal }
	);
}
